<ion-range
  #targetProgressFavs
  mode="ios"
  [value]="value"
  [max]="maxValue"
  [color]="color"
  class="progress-range"
  pin="true"
  [ngClass]="{
    'progress-range-0': value < 1,
    'progress-range-100': value >= maxValue
  }"
>
</ion-range>
